import { FunnelConfig } from '~/utils/funnels';

export const COMMUNITY_SOLAR_FUNNEL_ID = 'communitySolar';

export const config: FunnelConfig = {
  id: COMMUNITY_SOLAR_FUNNEL_ID,
  path: '/community-solar',
  show: () => true,
};
